
export const initialFormState = {
  avatar: {},
  first_name: "Somtochukwu",
  last_name: "Mazi",
  email: "mazi_somto1@gmail.com",
  phone: "+233 408 899 999",
  country: "nigeria"
}